import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'

import { USER_STAFF_EDIT_FUNCTIONAL_ROLE_FIELD_NAME } from './UserStaffEditFunctionalRoleFormModal.constants'

export function getUserStaffEditFunctionalRoleFormModalValidationSchema(
  initialValues
) {
  return formValidationSchemaNoChanged({ initialValues })
}

export function getUserStaffEditFunctionalRoleFormModalSubmitPayload(values) {
  return {
    [USER_STAFF_EDIT_FUNCTIONAL_ROLE_FIELD_NAME]:
      values[USER_STAFF_EDIT_FUNCTIONAL_ROLE_FIELD_NAME]?.value ?? null,
  }
}

export function toUserStaffFunctionalRoleSelectOption(functionalRole) {
  return functionalRole
    ? { label: functionalRole.name, value: functionalRole.id }
    : null
}

export function getUserStaffEditFunctionalRoleFormModalInitialValues(
  functionalRole
) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
    [USER_STAFF_EDIT_FUNCTIONAL_ROLE_FIELD_NAME]:
      toUserStaffFunctionalRoleSelectOption(functionalRole),
  }
}
